import { render, staticRenderFns } from "./ViewEmailModal.vue?vue&type=template&id=0f49ab66"
import script from "./ViewEmailModal.vue?vue&type=script&lang=js"
export * from "./ViewEmailModal.vue?vue&type=script&lang=js"
import style0 from "./ViewEmailModal.vue?vue&type=style&index=0&id=0f49ab66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports